var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm._f("validate")(_vm.value)))]),(_vm.canClose)?_c('button',{staticClass:"remove-btn",on:{"click":_vm.removeItem}},[_c('img',{attrs:{"src":require("@/assets/admin-icon/cross-icon.svg")}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }